// src/api/asset.js
import request from "../utils/request";
import dayjs from "dayjs";
const apiPrefix = "/asset";
// 新增分类
export const createAssetCategory = (data) => {
  return request.post(`${apiPrefix}/asset-categories`, data);
};

// 获取分类列表
export const getAssetCategories = () => {
  return request.get(`${apiPrefix}/asset-categories`);
};

// 删除分类
export const deleteAssetCategory = (id) => {
  return request.delete(`${apiPrefix}/asset-categories/${id}`);
};

// 更新分类（你已经写的）
export const updateAssetCategory = (id, data) => {
  return request.put(`${apiPrefix}/asset-categories/${id}`, data);
};

// =========================
// 采购记录
// =========================

// 获取列表
export const getPurchaseRecords = (params) => {
  return request.get(`${apiPrefix}/purchase-records`, { params });
};

// 查询指定日期范围内的采购记录数量
export const countPurchaseRecordsByDate = (date) => {
  // console.log("date", date);
  const dayStr = dayjs(date).format("YYYYMMDD");
  return request.get(`${apiPrefix}/count-purchase-by-date`, {
    params: { dayStr },
  });
};
// 创建
export const createPurchaseRecord = (data) => {
  return request.post(`${apiPrefix}/purchase-records`, data);
};

// 更新
export const updatePurchaseRecord = (id, data) => {
  return request.put(`${apiPrefix}/purchase-records/${id}`, data);
};

// =========================
// 资产（入库生成）
// =========================

// 批量生成资产
export const createAssetsBatch = (data) => {
  return request.post(`${apiPrefix}/assets/batch`, data);
};
export const createAsset = (data) => {
  return request.post(`${apiPrefix}/assets`, data);
};
export const getAssets = (params, config) =>
  request.get(`${apiPrefix}/assets`, { params, ...config });
export const getAssetDetail = (id) => {
  return request.get(`${apiPrefix}/assets/${id}`);
};
export const getAssetCount = (date) => {
  const startDate = dayjs(date).format("YYYY-MM-DD");
  const endDate = startDate;

  return request.get(`${apiPrefix}/count-assets-by-date`, {
    params: { startDate, endDate },
  });
};
export const updateAsset = (id, data) => {
  return request.put(`${apiPrefix}/assets/${id}`, data);
};
export const getTransactions = (params) => {
  return request.get(`${apiPrefix}/asset-transactions`, { params });
};
export const createTransaction = (data) => {
  return request.post(`${apiPrefix}/asset-transactions`, data);
};
export const updateTransaction = (id, data) => {
  return request.put(`${apiPrefix}/asset-transactions/${id}`, data);
};
